"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReducedMotion = void 0;
var use_media_query_1 = require("../use-media-query/use-media-query");
function useReducedMotion() {
    return use_media_query_1.useMediaQuery('(prefers-reduced-motion: reduce)');
}
exports.useReducedMotion = useReducedMotion;
